/* ============================================
   LUXURY FASHION THEME - JavaScript
   ============================================ */

(function() {
  'use strict';

  // ============================================
  // Mobile Menu
  // ============================================
  const mobileMenu = {
    init() {
      const toggleBtn = document.querySelector('[data-menu-toggle]');
      const closeBtn = document.querySelector('[data-menu-close]');
      const menu = document.querySelector('[data-mobile-menu]');

      if (!toggleBtn || !menu) return;

      toggleBtn.addEventListener('click', () => {
        menu.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      });

      if (closeBtn) {
        closeBtn.addEventListener('click', () => {
          menu.classList.remove('is-open');
          document.body.style.overflow = '';
        });
      }
    }
  };

  // ============================================
  // Search Overlay
  // ============================================
  const searchOverlay = {
    init() {
      const toggleBtn = document.querySelector('[data-search-toggle]');
      const closeBtn = document.querySelector('[data-search-close]');
      const overlay = document.querySelector('[data-search-overlay]');
      const input = document.querySelector('[data-search-input]');

      if (!toggleBtn || !overlay) return;

      toggleBtn.addEventListener('click', () => {
        overlay.classList.add('is-open');
        document.body.style.overflow = 'hidden';
        if (input) setTimeout(() => input.focus(), 300);
      });

      if (closeBtn) {
        closeBtn.addEventListener('click', () => {
          overlay.classList.remove('is-open');
          document.body.style.overflow = '';
        });
      }
    }
  };

  // ============================================
  // Cart Drawer
  // ============================================
  const cartDrawer = {
    init() {
      const openBtns = document.querySelectorAll('[data-cart-toggle]');
      const closeBtn = document.querySelector('[data-cart-close]');
      const drawer = document.querySelector('[data-cart-drawer]');
      const overlay = document.querySelector('[data-cart-overlay]');

      if (!drawer) return;

      openBtns.forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          this.open();
        });
      });

      if (closeBtn) {
        closeBtn.addEventListener('click', () => this.close());
      }

      if (overlay) {
        overlay.addEventListener('click', () => this.close());
      }
    },

    open() {
      const drawer = document.querySelector('[data-cart-drawer]');
      const overlay = document.querySelector('[data-cart-overlay]');
      if (drawer) drawer.classList.add('is-open');
      if (overlay) overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    },

    close() {
      const drawer = document.querySelector('[data-cart-drawer]');
      const overlay = document.querySelector('[data-cart-overlay]');
      if (drawer) drawer.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-open');
      document.body.style.overflow = '';
    }
  };

  // ============================================
  // Header Scroll Behavior
  // ============================================
  const headerScroll = {
    init() {
      const header = document.querySelector('[data-header]');
      if (!header) return;

      let lastScroll = 0;
      const threshold = 100;

      window.addEventListener('scroll', () => {
        const currentScroll = window.pageYOffset;

        if (currentScroll > threshold && currentScroll > lastScroll) {
          header.classList.add('is-hidden');
        } else {
          header.classList.remove('is-hidden');
        }

        lastScroll = currentScroll;
      }, { passive: true });
    }
  };

  // ============================================
  // Product Accordions
  // ============================================
  const productAccordions = {
    init() {
      const accordions = document.querySelectorAll('[data-accordion]');

      accordions.forEach(accordion => {
        const header = accordion.querySelector('[data-accordion-header]');
        if (!header) return;

        header.addEventListener('click', () => {
          accordion.classList.toggle('is-open');
        });
      });
    }
  };

  // ============================================
  // Product Variant Selector
  // ============================================
  const variantSelector = {
    init() {
      const options = document.querySelectorAll('[data-variant-option]');

      options.forEach(option => {
        option.addEventListener('click', () => {
          const group = option.closest('[data-variant-group]');
          if (!group) return;

          group.querySelectorAll('[data-variant-option]').forEach(opt => {
            opt.classList.remove('is-active');
          });
          option.classList.add('is-active');

          // Update hidden variant input
          this.updateVariant();
        });
      });
    },

    updateVariant() {
      const activeOptions = document.querySelectorAll('[data-variant-option].is-active');
      const variantInput = document.querySelector('[data-variant-id]');
      if (!variantInput) return;

      // Build variant string from active options
      const values = [];
      activeOptions.forEach(opt => values.push(opt.dataset.value));

      // Find matching variant
      const variantsJson = document.querySelector('[data-product-variants]');
      if (!variantsJson) return;

      try {
        const variants = JSON.parse(variantsJson.textContent);
        const match = variants.find(v => {
          return v.options.every((opt, i) => opt === values[i]);
        });

        if (match) {
          variantInput.value = match.id;
          // Update price display
          const priceEl = document.querySelector('[data-product-price]');
          if (priceEl) {
            priceEl.textContent = this.formatMoney(match.price);
          }
        }
      } catch (e) {
        console.error('Error parsing variants:', e);
      }
    },

    formatMoney(cents) {
      return '$' + (cents / 100).toFixed(2);
    }
  };

  // ============================================
  // Add to Cart (AJAX)
  // ============================================
  const addToCart = {
    init() {
      const forms = document.querySelectorAll('[data-add-to-cart-form]');

      forms.forEach(form => {
        form.addEventListener('submit', async (e) => {
          e.preventDefault();
          const btn = form.querySelector('[data-add-to-cart-btn]');
          if (!btn) return;

          btn.disabled = true;
          btn.textContent = 'ADDING...';

          try {
            const formData = new FormData(form);
            const response = await fetch('/cart/add.js', {
              method: 'POST',
              body: formData
            });

            if (response.ok) {
              btn.textContent = 'ADDED';
              this.updateCartCount();
              cartDrawer.open();
              this.refreshCartDrawer();

              setTimeout(() => {
                btn.disabled = false;
                btn.textContent = 'ADD TO BAG';
              }, 2000);
            } else {
              throw new Error('Failed to add');
            }
          } catch (error) {
            btn.disabled = false;
            btn.textContent = 'ADD TO BAG';
            console.error('Add to cart error:', error);
          }
        });
      });
    },

    async updateCartCount() {
      try {
        const response = await fetch('/cart.js');
        const cart = await response.json();
        const countEls = document.querySelectorAll('[data-cart-count]');
        countEls.forEach(el => {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? 'flex' : 'none';
        });
      } catch (e) {
        console.error('Error updating cart count:', e);
      }
    },

    async refreshCartDrawer() {
      try {
        const response = await fetch('/?section_id=cart-drawer');
        const html = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newDrawer = doc.querySelector('[data-cart-drawer-content]');
        const currentDrawer = document.querySelector('[data-cart-drawer-content]');
        if (newDrawer && currentDrawer) {
          currentDrawer.innerHTML = newDrawer.innerHTML;
        }
      } catch (e) {
        console.error('Error refreshing cart:', e);
      }
    }
  };

  // ============================================
  // Scroll Animations
  // ============================================
  const scrollAnimations = {
    init() {
      const elements = document.querySelectorAll('[data-animate]');
      if (!elements.length) return;

      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('fade-in');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.1 });

      elements.forEach(el => observer.observe(el));
    }
  };

  // ============================================
  // Initialize
  // ============================================
  document.addEventListener('DOMContentLoaded', () => {
    mobileMenu.init();
    searchOverlay.init();
    cartDrawer.init();
    headerScroll.init();
    productAccordions.init();
    variantSelector.init();
    addToCart.init();
    scrollAnimations.init();
  });

})();
